<template>
  <KeepAlive>
    <div class="m-0 p-0">
      <div
        class="sumo-browse-main"
      >
        <section>
          <smart-collection
            v-for="(item, index) in smartCollections"
            :key="item.id"
            :collection="item"
            :use-intersection="index >= maxCollectionServerFetch"
          />
        </section>
      </div>
    </div>
  </KeepAlive>
</template>

<script>
import PrivyMixin from '~/mixins/add-privy';
import SmartCollection from '~/components/smartcollections/SmartCollection';

const ANONYMOUS_USER = 'a';

// TODO: use feature flagging here once available
if (process.browser) {
  window.elasticsearch_is_active = false;
}

export default {
  components: {
    SmartCollection,
  },
  mixins: [PrivyMixin],
  layout: 'base',
  async asyncData(context) {
    const { $cachios, store } = context;
    const userId = store.state.session?.user?.id || ANONYMOUS_USER;
    const { handler } = await import(
      /* webpackChunkName: 'datalayer-page-index' */ '@/datalayer/pages/home'
    );

    const {
      smartCollections,
    } = await handler($cachios, userId);

    if (smartCollections) {
      if (userId === ANONYMOUS_USER) {
        // anonymous users get an email capture
        smartCollections.splice(2, 0, { id: 'email_capture', component_type: 'email_capture' });
      } else if (!store.state.session?.user?.has_plus) {
        // non-plus users get a request to join plus
        smartCollections.splice(2, 0, { id: 'plus_promo', component_type: 'plus_promo' });
      }
    }

    return {
      smartCollections,
    };
  },
  data() {
    return {
      maxCollectionServerFetch: 3,
    };
  },
  head() {
    return {
      title: 'Stop overpaying for software. | AppSumo',
      bodyAttrs: {
        class: ['sumo-browse-page', 'search-sticky-header'],
      },
    };
  },
  mounted() {
    if (!this.showWelcomeMat) {
      document.body.classList.remove('sumo-onboarding-page', 'dark-scheme');
    }
  },
};
</script>
